import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"

interface Props {
  ctaLabel: string
  onCtaClick: () => void
}

const FiltersPanelFooter = ({ ctaLabel, onCtaClick }: Props) => {
  return (
    <div className="px-4 py-2">
      <CustomButton onClick={onCtaClick} fullWidth>
        {ctaLabel}
      </CustomButton>
    </div>
  )
}

export default FiltersPanelFooter
